import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { TableBaseStyle } from '../../../baseStyle/tableBaseStyle';

const useStyles = makeStyles(
  createStyles({
    //テーブル外枠
    tableStyle: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
    },
    //テーブルヘッダセル
    tableHeaderCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
    },
    //テーブルヘッダセル
    tableHeaderLeftCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'left',
      color: 'white',
    },
    //テーブルボディーセル
    tableCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'center',
      minWidth: '100px',
    },
    tableLeftCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      textAlign: 'left',
      minWidth: '100px',
    },
    tableRow: {
      '&.Mui-selected, &.Mui-selected:hover': {
        //背景色
        backgroundColor: '#7fffd4',
        '& > .MuiTableCell-root': {
          //文字色
          color: 'brack',
        },
      },
    },
  })
);

export type Props = {
  groupList: SelectGroupType[];
  tableContainerStyle?: string;
  onSelect: (selectdata: SelectGroupType) => void;
};

export type SelectGroupType = {
  index: number;
  groupNo: number;
  groupName: string;
};

const GroupSelectPage: React.FC<Props> = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const baseClasses = TableBaseStyle();
  const [selectedID, setSelectedID] = useState(0);
  const { t } = useTranslation();

  console.debug('GroupSelectPage');

  //行選択の背景色一時置き
  let lineSelection = '';

  return (
    <div>
      <div className={`${(lineSelection = classes.tableRow)} ${(lineSelection = baseClasses.bodyRow)}`}></div>
      <TableContainer component={Paper} className={props.tableContainerStyle ?? ''}>
        <Table aria-label="GroupSelectPage" stickyHeader className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              {/* <TableCell className={classes.tableHeaderCell} align="center">
              No
            </TableCell> */}
              <TableCell className={classes.tableHeaderCell} width={200} align="center">
                {t('GroupSelectPage.グループNo', 'グループNo')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell} align="center">
                {t('GroupSelectPage.グループ名称', 'グループ名称')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.groupList?.map((item, index) => (
              <TableRow
                hover
                key={index + 1}
                onClick={() => {
                  if (selectedID == index + 1) {
                    props.onSelect(item);
                  } else {
                    setSelectedID(index + 1);
                  }
                }}
                selected={selectedID === index + 1}
                className={lineSelection}
              >
                {/* <TableCell className={classes.tableCell}>{index + 1}</TableCell> */}
                <TableCell className={classes.tableCell}>{item.groupNo}</TableCell>
                <TableCell className={classes.tableCell}>{item.groupName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default GroupSelectPage;
